export default __webpack_public_path__ + "static/media/contact.a77d4f52.jpg";